import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function scrollWindowToTop() {
  window.scrollTo(0, 0);
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
}

/**
 * Restores window scroll to the top on route changes. Without this, React Router
 * and the browser can keep the previous page's scroll position, which disorients
 * users on new views. Skips when navigating to #comments (PostDetail handles that).
 */
export default function ScrollToTop() {
  const location = useLocation();
  const shouldSkip = location.hash === '#comments';

  useLayoutEffect(() => {
    if (typeof window.history?.scrollRestoration !== 'undefined') {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (shouldSkip) return;
    scrollWindowToTop();
  }, [location.pathname, location.search, location.key, shouldSkip]);

  // Second pass after paint — catches async layout from fetched content/images.
  useEffect(() => {
    if (shouldSkip) return;
    scrollWindowToTop();
    const raf = requestAnimationFrame(scrollWindowToTop);
    const timer = window.setTimeout(scrollWindowToTop, 0);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(timer);
    };
  }, [location.pathname, location.search, location.key, shouldSkip]);

  return null;
}
